const buildNonPlaygroundLink = ({
  userId,
  projectId,
}: {
  userId: string;
  projectId: string;
}): string => `/learner/${userId}/my_courses/project/${projectId}`;

export default buildNonPlaygroundLink;
